import React, { useState } from "react";
import { TabsMax } from "../../_molecules/_tabs-max/TabsMax";
import { BsiContent } from "./BsiContent";
import { ClosedPricesContent } from "./ClosedPricesContent";
import { Alert } from "../../_molecules/_alert/Alert";
import { LinkSimple } from "../../_atoms/_link-simple/LinkSimple";
import { sendAnalytics } from "../../../utils/analytics";

export const MaintenanceTabs = ({
  bsiData,
  closedPricesData,
  showClosedPrices,
}) => {
  const [state, setState] = useState({
    tab: "bsi",
  });

  const { tab } = state;

  const changeTab = (id) => {
    setState({ ...state, tab: id });
  };

  //Datos que nos envía el padre
  let { tabs } = bsiData; // BSI
  let dataBSI;
  //Comprobamos si el WS devuelve tabs (los precios)
  //Si lo devuelve enviamos al componente todos los datos de bsiData
  tabs ? (dataBSI = bsiData) : (dataBSI = false);

  const renderBSIContent = (dataBSI) => {
    if (dataBSI === false) {
      return (
        <Alert css="alert--info">
          <ul className="list list--icons list--icons--md">
            <li>
              <div className="text">
                <svg className="icon">
                  <use xlinkHref="./svg/sprite.svg#form-info"></use>
                </svg>
                En caso de que tu vehículo no disponga de Paquete de
                Mantenimiento Service Inclusive puedes contactar con tu{" "}
                <LinkSimple
                  href="https://www.bmw.es/es/ssl/citaprevia/encuentra-tu-concesionario.html"
                  target="_blank">
                  Taller Autorizado {bsiData.brand}
                </LinkSimple>{" "}
                para más información o bien consultar el programa Precios
                Cerrados.
              </div>
            </li>
          </ul>
        </Alert>
      );
    } else {
      return <BsiContent data={dataBSI} />;
    }
  };

  return (
    <>
      <div className="container-selectProgram">
        <span className="h3 selectProgram">Selecciona el programa</span>
      </div>
      <TabsMax>
        <li>
          <button
            className={tab === "bsi" ? "is-active" : ""}
            type="button"
            onClick={() => changeTab("bsi")}
            onClick={() => {
              changeTab("bsi");
              // Send analytics for clicking on the BSI tab
              sendAnalytics("Click en tab", `${bsiData.brand.toUpperCase()} Service Inclusive - Paquetes de mantenimiento`);
            }}
          >
            {bsiData.brand.toUpperCase()} Service Inclusive
            <br />
            <span className="h5">Paquetes de mantenimiento</span>
          </button>
        </li>
        {showClosedPrices && (
          <li>
            <button
              className={tab === "closed" ? "is-active" : ""}
              type="button"
              onClick={() => {
                changeTab("closed");
                // Send analytics for clicking on the Closed Prices tab
                sendAnalytics("Click en tab", `${bsiData.brand.toUpperCase()} Precios Cerrados - Operaciones puntuales`);
              }}
              >
              {bsiData.brand.toUpperCase()} Precios Cerrados
              <span className="h5">Operaciones puntuales</span>
            </button>
          </li>
        )}
      </TabsMax>
      <div>
        {tab === "bsi" ? (
          renderBSIContent(dataBSI)
        ) : (
          <ClosedPricesContent
            contractedBSI={bsiData.type}
            data={closedPricesData}
          />
        )}
      </div>
    </>
  );
};
